const moduleMap = {
	"./CorporateResource": () => {
		return Promise.all([__webpack_require__.e(242), __webpack_require__.e(67), __webpack_require__.e(19), __webpack_require__.e(317), __webpack_require__.e(543), __webpack_require__.e(562), __webpack_require__.e(356), __webpack_require__.e(846), __webpack_require__.e(795), __webpack_require__.e(404), __webpack_require__.e(161), __webpack_require__.e(766), __webpack_require__.e(289), __webpack_require__.e(18), __webpack_require__.e(477), __webpack_require__.e(326), __webpack_require__.e(580), __webpack_require__.e(352), __webpack_require__.e(956), __webpack_require__.e(81), __webpack_require__.e(127), __webpack_require__.e(114), __webpack_require__.e(139), __webpack_require__.e(439), __webpack_require__.e(548), __webpack_require__.e(884), __webpack_require__.e(633), __webpack_require__.e(276), __webpack_require__.e(106), __webpack_require__.e(724), __webpack_require__.e(508)]).then(() => (() => ((__webpack_require__(53250)))));
	},
	"./CorporateNavigation": () => {
		return __webpack_require__.e(802).then(() => (() => ((__webpack_require__(49802)))));
	},
	"./corporateCore": () => {
		return Promise.all([__webpack_require__.e(242), __webpack_require__.e(537), __webpack_require__.e(18), __webpack_require__.e(802), __webpack_require__.e(787), __webpack_require__.e(621), __webpack_require__.e(29)]).then(() => (() => ((__webpack_require__(69029)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});